module.exports = __webpack_public_path__ + "img/rashodnye-materialy.1900bdbb.svg";